export default import.meta.ROLLDOWN_FILE_URL_28_txB5aERK3lAL1e_7BwA